import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getMarketingConsent, initPixel, setMarketingConsent, track } from "@/utils/metaPixel";

/* Bandeau de consentement (ES) — le pixel Meta ne se charge qu'après « Aceptar ».
   Après le choix, le bandeau ne réapparaît plus (cookie marketing_consent,
   6 mois) — sauf si le visiteur supprime ses cookies ou clique « Cookies » en pied de page. */
export const CookieBanner = () => {
    const [choice, setChoice] = useState(() => getMarketingConsent() !== null);

    if (choice) return null;

    const accept = () => {
        setMarketingConsent("accepted");
        setChoice("accepted");
        if (initPixel()) track("PageView");
    };
    const reject = () => {
        setMarketingConsent("rejected");
        setChoice("rejected");
    };

    return (
        <aside
            data-testid="cookie-consent-banner"
            role="dialog"
            aria-label="Consentimiento de cookies"
            className="fixed bottom-4 left-4 right-4 z-[70] mx-auto max-w-md rounded-2xl border border-bordeaux/20 bg-cream p-4 shadow-2xl"
        >
            <div className="flex items-start gap-3">
                <Cookie className="h-5 w-5 shrink-0 text-bordeaux mt-0.5" strokeWidth={2} />
                <div>
                    <p className="text-sm text-ink leading-snug">
                        Usamos cookies de marketing para medir nuestras campañas y mejorar tu
                        experiencia.{" "}
                        <Link to="/legal/privacidad" className="underline text-bordeaux font-semibold">
                            Más información
                        </Link>
                    </p>
                    <div className="mt-3 flex gap-2">
                        <button
                            data-testid="cookie-accept-button"
                            onClick={accept}
                            className="rounded-full bg-bordeaux px-5 py-2 text-sm font-bold text-white transition-transform hover:scale-[1.03] active:scale-95"
                        >
                            Aceptar
                        </button>
                        <button
                            data-testid="cookie-reject-button"
                            onClick={reject}
                            className="rounded-full border border-bordeaux/40 px-5 py-2 text-sm font-semibold text-bordeaux transition-colors hover:bg-bordeaux/5"
                        >
                            Rechazar
                        </button>
                    </div>
                </div>
            </div>
        </aside>
    );
};
